import type { Addon as PopsAddon } from '@/types/pops'
import type { CMSProgramAddonOption } from '@/types/sanity'

export class Addon {
  id: number
  title: string
  shopifyVariantId: number
  shopifySku: string
  pricePerUnit: number
  category?: string
  config: CMSProgramAddonOption

  constructor(rawAddon: PopsAddon, config: CMSProgramAddonOption) {
    this.id = rawAddon.id
    this.title = rawAddon.title
    this.shopifyVariantId = rawAddon.shopify_variant_id
    this.shopifySku = rawAddon.shopify_sku
    this.pricePerUnit = parseFloat(rawAddon.price_per_unit)
    this.category = rawAddon.category
    this.config = config
  }
}
